import { usecreatePaymentIntentMutation, PaymentIntentInput } from '@/types/generated/graphql';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';

export const useCreatePaymentIntent = () => {
  const { t } = useTranslation();
  const [create, { data, loading, error }] = usecreatePaymentIntentMutation({
    onError: (error) => {
      notification.error({
        message: error?.message || t('something_went_wrong_while_creating_payment_intent'),
      });
    },
  });

  const createPaymentIntent = async (input: PaymentIntentInput) => {
    return create({
      variables: { input },
    });
  };

  return {
    error,
    createPaymentIntent,
    creatingPaymentIntent: loading,
    paymentIntent: data?.createPaymentIntent?.data,
  };
};
